export default __webpack_public_path__ + "static/media/facebook.3fce9a4c.svg";